import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import {
  HttpService,
  API,
  Permissionkeys,
  Title,
  DateFormat,
  Common,
  Spinner,
  ExportToExcel
} from '../../config/react'
import MultiSelect from 'react-multiple-select-dropdown-lite'
import 'react-multiple-select-dropdown-lite/dist/index.css'
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars'
import '../../assests/fonts/mdi/css/material.css'
import DataTable from 'react-data-table-component'

const Orders = () => {
  const history = useHistory()
  const path = useLocation()
  const [OrderList, setOrderList] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [OrderStatusList, setOrderStatusList] = useState([])
  const [ShowFilters, setShowFilters] = useState(false)
  const [Countries] = useState([])
  const [totalRows, settotalRows] = useState()
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(
    path.state
      ? parseInt(path.state.state.page) === 0 || isNaN(path.state.state.page)
        ? 1
        : parseInt(path.state.state.page)
      : 1
  )
  const DefaultFilters = {
    ordernumber: path.state?.state?.ordernumber !== undefined ? path.state.state.ordernumber : '',
    email: path.state?.state?.email !== undefined ? path.state.state.email : '',
    status:
      path.state?.state?.status !== undefined && path.state?.state?.status !== null
        ? path.state.state.status
        : '',
    orderfromdate:
      path.state?.state?.orderfromdate !== undefined && path.state?.state?.orderfromdate !== null
        ? new Date(path.state.state.orderfromdate)
        : '',
    ordertodate:
      path.state?.state?.ordertodate !== undefined && path.state?.state?.ordertodate !== null
        ? new Date(path.state.state.ordertodate)
        : '',
    country: '',
    name: path.state?.state?.name !== undefined ? path.state.state.name : '',
    paymentmethod: '',
    page: path.state
      ? parseInt(path.state.state.page) === 0 ||
        path.state?.state?.page === undefined ||
        path.state?.state?.page === null ||
        isNaN(path.state.state.page)
        ? 1
        : parseInt(path.state.state.page)
      : 1,
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const columns = [
    // {
    //     name: 'Id',
    //     selector: row => row.id,
    // },
    {
      name: 'Order Number',
      selector: (row) => row.order_number,
      wrap: true
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      wrap: true
    },
    {
      name: 'Is Guest',
      selector: (row) => (row.customer_is_guest === 1 ? 'YES' : 'NO')
    },
    {
      name: 'Total',
      selector: (row) => row.symbol + row.final_price
    },
    {
      name: 'Item(s)',
      selector: (row) => row.qty
    },
    {
      name: 'Order Status',
      selector: (row) => row.order_status
    },
    {
      name: 'Order Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      wrap: true
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={
              '/order/view/order_id/' +
              row.order_number +
              '?page=' +
              CustomFilters.page +
              '&ordernumber=' +
              CustomFilters.ordernumber +
              '&email=' +
              CustomFilters.email +
              '&orderfromdate=' +
              CustomFilters.orderfromdate +
              '&ordertodate=' +
              CustomFilters.ordertodate +
              '&status=' +
              CustomFilters.status +
              '&name=' +
              CustomFilters.name
            }
            className="text-dark"
            title="View"
          >
            <i
              className="mdi mdi-eye"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          {row.invoice_path !== undefined && row.invoice_path !== '' ? (
            <a
              href={row.invoice_path}
              rel="noreferrer"
              className="text-dark"
              title="Invoice"
            >
              <i
                className="fa fa-file-pdf-o"
                aria-hidden="true"
              ></i>{' '}
            </a>
          ) : (
            ''
          )}
        </div>
      )
    }
  ]

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Sales)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.Order
    GetOrderList()
    GetCountryList()
    GetOrderStatusList()
  }, [CustomFilters])

  const GetOrderStatusList = (statusId) => {
    HttpService.getApi(API.GetOrderStatusList).then((response) => {
      const data = response.data.result
      const productData = []
      for (const key in data) {
        productData.push({ label: data[key].status, value: data[key].status.toUpperCase() })
      }
      setOrderStatusList(productData)
    })
  }

  const GetOrderList = () => {
    const orderData = {
      ordernumber: CustomFilters.ordernumber,
      email: CustomFilters.email,
      status: CustomFilters.status,
      orderfromdate: CustomFilters.orderfromdate,
      ordertodate: CustomFilters.ordertodate,
      country: CustomFilters.country,
      name: CustomFilters.name,
      paymentmethod: CustomFilters.paymentmethod,
      page: CustomFilters.page,
      page_size: CustomFilters.page_size
    }
    // HttpService.postApi(API.GetOrderLists, orderData)
    setLoading(true)
    HttpService.postApi(API.GetOrderAdminLists, orderData).then((response) => {
      setLoading(false)
      const data = response.data.result[1]
      // console.log(JSON.stringify(data[0]))
      setOrderList(data)
      settotalRows(response.data.result[0][0].total_row)
      setForceUpdate(!isForceUpdate)
    })
  }

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const handleInputChanges = (e, fieldName) => {
    if (fieldName === 'status' || fieldName === 'country' || fieldName === 'paymentmethod')
      Object.assign(CustomFilters, { [fieldName]: e })
    else if (fieldName === 'orderdate') {
      if (e.value !== null) {
        Object.assign(CustomFilters, { orderfromdate: e.value[0] })
        Object.assign(CustomFilters, { ordertodate: e.value[1] })
      } else {
        Object.assign(CustomFilters, { orderfromdate: '' })
        Object.assign(CustomFilters, { ordertodate: '' })
      }
    } else CustomFilters[fieldName] = e.target.value
    setForceUpdate(!isForceUpdate)
  }

  // const handleInputChanges = (prop) => (e) => {
  //   const priceLength = Messages.pricelength
  //   const lastPrice = Messages.pricehighest

  //   // console.log('priceLength '+priceLength+ ' & '+lastPrice);
  //   if (e.target.value.length > priceLength && (prop === 'priceTo' || prop === 'priceFrom')) {
  //     if (prop === 'priceFrom' && e.target.value > lastPrice)
  //       priceFrom.current.value = e.target.value.slice(0, priceLength)
  //     else if (prop === 'priceTo' && e.target.value > lastPrice)
  //       priceTo.current.value = e.target.value.slice(0, priceLength)
  //   } else {
  //     CustomFilters[prop] = e.target.value
  //   }
  //   setForceUpdate(!isForceUpdate)
  // }

  const GetCountryList = () => {
    HttpService.getApi(API.GetCountryWithCurrencyList).then((response) => {
      const data = response.data.result[0]
      const obj = []
      data.map((item, index) => {
        obj.push({ label: item.name, value: item.id })
        return true
      })
      Object.assign(Countries, obj)
    })
  }

  const openFilterBox = () => {
    if (ShowFilters) {
      setShowFilters(false)
    } else {
      setShowFilters(true)
    }
  }

  const handleExportExcel = () => {
    HttpService.getApi(API.GetOrderExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Orders')
      }
    })
  }
  const ClearFilter = () => {
    setCustomFilters(DefaultFilters)
    setClearMultiSelect([])
    setForceUpdate(!isForceUpdate)
  }
  const [setClearMultiSelect] = useState('rf,test,new')
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Order} </h3>
        <div className="btn-group ml-auto">
          <Link
            to="#"
            onClick={openFilterBox}
            className="btn btn-primary btn-fw rounded filter-btn mr-2"
          >
            {' '}
            Filters{' '}
          </Link>
        </div>
      </div>
      <div
        className={ShowFilters ? 'filter-bar d-block' : 'filter-bar'}
        id="filter-bar"
      >
        <div className="grid-margin w-100 stretch-card">
          <div className="card">
            <div className="card-body">
              <form>
                <div className="active-filter-box d-none mb-">
                  <div className="row justify-content-between">
                    <div className="col-md-10">
                      <div className="filter-result-list">
                        <span className="filter-result-repeat-title">Active Filter : </span>

                        {/* <span className="filter-result-repeat"><a>Name : <button className="btn-close"></button></a></span> */}
                        {/* <span className="filter-result-repeat"><a>Email :  <button className="btn-close"></button></a></span> */}
                        {/* <span className="filter-result-repeat"><a>Customer Group :  <button className="btn-close"></button></a></span>                                      */}
                      </div>
                    </div>
                    <div className="col-md-2 text-right">
                      <Link
                        to="#"
                        className="rounded mr-2 font-13"
                      >
                        {' '}
                        Clear All{' '}
                      </Link>
                    </div>
                  </div>
                  <hr></hr>
                </div>
                <div className="row">
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Order Number</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => handleInputChanges(e, 'ordernumber')}
                        value={CustomFilters.ordernumber}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Email</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => handleInputChanges(e, 'email')}
                        value={CustomFilters.email}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Name</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => handleInputChanges(e, 'name')}
                        value={CustomFilters.name}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Order Date</strong>
                      </label>
                      <DateRangePickerComponent
                        onChange={(e) => handleInputChanges(e, 'orderdate')}
                        value={[CustomFilters.orderfromdate, CustomFilters.ordertodate]}
                      ></DateRangePickerComponent>
                    </div>
                  </div>

                  {/* <div className="col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1"><strong>Date</strong></label>
                                            <div className="form-group mb-2 row align-items-center">
                                                <div className="col-md-6 pr-md-2">
                                                    <input type="date" className="form-control" placeholder="From" onChange={(e) => handleInputChanges(e, 'orderfromdate')} />
                                                </div>
                                                <div className="col-md-6 pl-md-2">
                                                    <input type="date" className="form-control" placeholder="To" onChange={(e) => handleInputChanges(e, 'ordertodate')} />
                                                </div>
                                            </div>

                                        </div>
                                    </div> */}
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Order Status</strong>
                      </label>
                      {
                        <MultiSelect
                          onChange={(e) => handleInputChanges(e, 'status')}
                          options={OrderStatusList}
                          defaultValue={CustomFilters.status.split(',')}
                        />
                      }
                    </div>
                  </div>
                  {/* <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Payment Method</strong>
                      </label>
                      {
                        <MultiSelect
                          onChange={(e) => handleInputChanges(e, 'paymentmethod')}
                          options={[
                            { label: 'Credit Card', value: 'credit_card' },
                            { label: 'Paypal', value: 'paypal' },
                            { label: 'Bank Transfer', value: 'bank_transfer' }
                          ]}
                          // value={[CustomFilters.paymentmethod]}
                        />
                      }
                    </div>
                  </div> */}
                  {/* <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        <strong>Country</strong>
                      </label>
                      <MultiSelect
                        onChange={(e) => handleInputChanges(e, 'country')}
                        options={Countries}
                        // value={[CustomFilters.country]}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-6 col-lg-3 mt-1 pt-3 text-left">
                    <div className="btn-group">
                      <Link
                        to="#"
                        className="btn btn-dark btn-fw-130 rounded mr-2"
                        onClick={(e) => GetOrderList(e)}
                      >
                        {' '}
                        Apply{' '}
                      </Link>
                    </div>
                    <div className="btn-group ml-auto">
                      {/* <Link to="#" className="btn btn-primary btn-fw rounded mr-2" onClick={e => ClearFilter(e)}> Cancel </Link> */}
                      <span className="filter-result-repeat">
                        <Link>
                          <button
                            className="btn btn-primary btn-fw-130 rounded mr-2"
                            onClick={ClearFilter}
                          >
                            Reset
                          </button>
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right mb-2"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={OrderList}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  responsive={true}
                  progressPending={loading}
                  paginationDefaultPage={currentPage}
                  progressComponent={<Spinner />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Orders
